import copy from 'copy-to-clipboard';

type Args = {
  onShare?: () => void;
} & ShareData;

export const shareHandler = ({ title, text, url, files, onShare }: Args) => {
  onShare?.();
  if ('share' in navigator) {
    navigator.share({ title, text, url, files });
  } else if (url) {
    copy(url);
  }
};
